import { render, staticRenderFns } from "./blogMenu.vue?vue&type=template&id=52cfeb1d&scoped=true"
import script from "./blogMenu.vue?vue&type=script&lang=ts"
export * from "./blogMenu.vue?vue&type=script&lang=ts"
import style0 from "./blogMenu.vue?vue&type=style&index=0&id=52cfeb1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cfeb1d",
  null
  
)

export default component.exports